import $ from 'jquery';
import config from './../../../config';

// Get Users
export function save_travel( data ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'travel/',
			data: {
                method: 'SAVE_TRAVEL',
                data: data
            }
		})
		.then(function (response) {
			dispatch({
				type: "SAVE_TRAVEL",
				travel: response
			})
		})

	}
}

export function get_travel_requests( user ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'travel/',
			data: {
                method: 'GET_TRAVEL',
                user: user
            }
		})
		.then(function (response) {
			dispatch({
				type: "GET_TRAVEL",
				travel: response
			})
		})

	}
}

export function delete_travel_requests( travel_id ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'travel/',
			data: {
                method: 'DELETE_TRAVEL',
                travel_id: travel_id
            }
		})
		.then(function (response) {
			dispatch({
				type: "DELETE_TRAVEL",
				travel: response
			})
		})

	}
}


export function get_travel_requests_by_id( travel_id ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'travel/',
			data: {
                method: 'GET_TRAVEL_BY_ID',
                travel_id: travel_id
            }
		})
		.then(function (response) {
			dispatch({
				type: "GET_TRAVEL_BY_ID",
				travel: response
			})
		})

	}
}


export function update_travel( data ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'travel/',
			data: {
                method: 'UPDATE_TRAVEL',
                data: data
            }
		})
		.then(function (response) {
			dispatch({
				type: "UPDATE_TRAVEL",
				travel: response
			})
		})

	}
}


// WEBPACK FOOTER //
// ./src/pages/travel/actions/travel.action.js